import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { auth } from './services/firebase';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import About from './pages/About';
import Login from './pages/Login';
import LoginConfirm from './pages/LoginConfirm';
import CheckEmail from './pages/CheckEmail';
import Members from './pages/Members';
import MemberDetail from './pages/MemberDetail';
import MemberEdit from './pages/MemberEdit';
import Itinerary from './pages/Itinerary';
import Dashboard from './pages/Dashboard';
import LoginLedger from './pages/LoginLedger';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

function ErrorBoundary({ children }: ErrorBoundaryProps) {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(
      (user) => {
        // Reset error on successful auth state change
        setError(null);
      },
      (error) => {
        setError(error.message);
      }
    );

    return () => unsubscribe();
  }, []);

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <Router>
      <ErrorBoundary>
        <div className="App">
          <Navigation />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login/confirm" element={<LoginConfirm />} />
            <Route path="/login/check-email" element={<CheckEmail />} />
            <Route path="/members" element={<Members />} />
            <Route path="/members/:id" element={<MemberDetail />} />
            <Route path="/members/:id/edit" element={<MemberEdit />} />
            <Route path="/itinerary" element={<Itinerary />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/login-ledger" element={<LoginLedger />} />
          </Routes>
        </div>
      </ErrorBoundary>
    </Router>
  );
} 